import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'ro',
    fullName: 'Romanian',
    nativeName: 'Română',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Urmează ceva uimitor",
    landing_subtitle: "ArgVoid este un studio de dezvoltare de aplicații și jocuri. Rămâneți pe fază, în curând vor veni lucruri noi!",
    select_language: "Selectați Limbă",
    search_placeholder: "Căutați limbi...",
    terms_title: "Termeni și condiții",
    policy_title: "Politica de confidențialitate",
    cookies_title: "Politica de cookie-uri",
    terms_content: `
        <strong>1. Acceptarea Termenilor</strong><br>
        Prin accesarea ArgVoid, acești Termeni și condiții sunt acceptați. Dacă acești termeni nu sunt acceptați, serviciul nu trebuie utilizat.<br><br>

        <strong>2. Utilizarea platformei</strong><br>
        ArgVoid și aplicațiile sale sunt furnizate „ca atare” în scopuri informaționale și creative. Serviciul trebuie utilizat numai în scopuri legale.<br><br>

        <strong>3. Conduită interzisă</strong><br>
        Exploatarea vulnerabilităților site-ului, trimiterea de spam sau încercarea de acces neautorizat la infrastructură este strict interzisă.<br><br>

        <strong>4. Disclaimer</strong><br>
        Platforma și serviciile pot fi modificate în orice moment fără notificare. Nu se oferă nicio garanție cu privire la timpul de funcționare sau disponibilitatea serviciului.
    `,
    policy_content: `
        <strong>1. Colecția de informații</strong><br>
        Platforma nu necesită autentificarea utilizatorului sau crearea unui cont în acest moment. Nicio informație personală de identificare (cum ar fi numele sau adresele de e-mail) nu este colectată în mod activ de la vizitatori.<br><br>

        <strong>2. Date de utilizare</strong><br>
        Analizele de bază, anonimizate, pot fi colectate pentru a înțelege traficul site-ului și pentru a îmbunătăți aplicațiile. Aceste date nu sunt legate de identitățile individuale ale utilizatorilor.<br><br>

        <strong>3. Servicii terță parte</strong><br>
        Furnizorii terți pot fi utilizați pentru servicii de găzduire și analiză. Practicile de confidențialitate ale acestor furnizori respectivi guvernează datele anonime procesate în infrastructura lor.<br><br>

        <strong>4. Securitatea datelor</strong><br>
        Sunt implementate măsuri de securitate rezonabile pentru a proteja platforma. Cu toate acestea, nicio metodă de transmitere prin Internet nu este complet sigură.<br><br>
    `,
    cookies_content: `
        <strong>1. Ce sunt cookie-urile și stocarea locală?</strong><br>
        Cookie-urile și stocarea locală a browserului sunt fișiere mici de date stocate pe dispozitiv pentru a reține preferințele de configurare în timpul vizitelor.<br><br>

        <strong>2. Scop de utilizare</strong><br>
        Browser LocalStorage este folosit strict pentru a salva setările de configurare, cum ar fi:<br>
        - Preferințe de limbă<br>
        - Configurarea interfeței cu utilizatorul (de exemplu, setări de aspect sau tema) <br>
        - Cache de aplicație temporară<br><br>

        <strong>3. Fără urmărire</strong><br>
        Cookie-urile și stocarea locală nu sunt utilizate în scopuri publicitare sau de urmărire terță parte. Toate datele stocate sunt strict pentru funcționalitatea de bază a platformei.<br><br>

        <strong>4. Control</strong><br>
        Datele browserului pot fi șterse oricând prin setările browserului, care vor reseta orice configurație locală.
    `,
    cookie_consent_text: "Folosim module cookie de bază pentru a ne asigura că site-ul web funcționează corect, cum ar fi menținerea activă a sesiunii, salvarea preferinței de limbă și alte configurații personalizate.",
    read_policy: "Citiți Politica privind cookie-urile",
    support_title: "Contactați asistența",
    support_subject_label: "Subiect",
    support_message_label: "Mesaj",
    support_submit_button: "Trimite mesaj",
    support_hint: "Notă: Aceasta va deschide aplicația implicită de e-mail pentru a trimite mesajul.",
    support_success_msg: "Se deschide aplicația de e-mail...",
    support_error_msg: "Trimiterea mesajului a eșuat. Vă rugăm să încercați din nou mai târziu.",
    explorer_title: "Explorator",
    history_title: "Istorie",
    animation_title: "Animaţie",
    config_title: "Configurare",
    tool_mouse: "Selectați (Ctrl+M)",
    tool_brush: "Pensula (Ctrl+B)",
    tool_brush_mode: "Comutare mod (Solid/Clear)",
    tool_eraser: "Eraser (Ctrl+E)",
    tool_brush_size: "Reglați dimensiunea pensulei",
    tool_bucket: "Umpleți (Ctrl+F)",
    tool_eyedropper: "Picura",
    tool_grid: "Grilă (Ctrl+Shift+B)",
    tool_rotate: "Rotiți (Ctrl+Shift+R)",
    tool_flip_h: "Întoarceți H (Ctrl+Shift+H)",
    tool_flip_v: "Întoarceți V (Ctrl+Shift+V)",
    tool_transpose: "Transpunere (Ctrl+Shift+T)",
    label_width: "Lăţime",
    label_height: "Înălţime",
    label_frames: "Numărul de cadre",
    label_animation: "Stil de animație",
    label_background_color: "Culoare de fundal",
    label_interval: "Interval",
    tool_anim_config: "Configurare animație",
    label_new_width: "Latime noua",
    label_new_height: "Înălțime nouă",
    label_apply: "Aplicați",
    label_colors: "Culori",
    label_size: "Dimensiune",
    label_tolerance: "Toleranţă",
    val_horizontal: "Orizontală",
    val_vertical: "Vertical",
    val_sequence: "Secvenţă",
    val_bounce: "Sări",
    val_random: "Aleatoriu",
    val_solid: "Solid",
    val_clear: "Clar",
    action_add_sheet: "Foaie nouă",
    action_import: "Import",
    action_export: "Export",
    action_sort_projects: "Sorta",
    sort_date_old: "Cel mai vechi primul",
    sort_date_new: "Cel mai nou primul",
    sort_name_az: "Nume (A-Z)",
    sort_name_za: "Nume (Z-A)",
    action_new_sprite: "Sprite nou",
    action_new_project: "Proiect nou",
    modal_save_all_title: "Salvați toate modificările",
    modal_save_all_desc: "Selectați activele de salvat:",
    modal_save_selected: "Salvați selectat",
    action_saved: "Salvat",
    modal_create_sprite_title: "Creați un nou Sprite",
    modal_create_project_title: "Creați un nou proiect",
    modal_add_sheet_title: "Adăugați o foaie nouă",
    modal_rename_sheet_title: "Redenumiți foaia",
    modal_rename_sprite_title: "Redenumiți Sprite",
    modal_delete_sprite_title: "Șterge Sprite",
    modal_delete_project_title: "Ștergeți proiectul",
    modal_delete_sheet_title: "Șterge foaia",
    placeholder_sprite_name: "Nume",
    placeholder_project_name: "Nume",
    placeholder_sheet_name: "Nume",
    placeholder_new_name: "Nume nou",
    action_create: "Crea",
    action_add: "Adăuga",
    action_rename: "Redenumiți",
    action_duplicate: "Duplicat",
    action_delete: "Şterge",
    action_cancel: "Anula",
    confirm_delete_sprite: "Sigur doriți să ștergeți acest sprite?",
    confirm_delete_project: "Sigur doriți să ștergeți acest proiect? Toate sprite-urile vor fi eliminate.",
    confirm_delete_sheet: "Sigur doriți să ștergeți această foaie?",
    err_select_sprite: "Vă rugăm să selectați mai întâi un sprite.",
    err_select_project: "Vă rugăm să selectați mai întâi un proiect.",
    err_name_empty: "Numele nu poate fi gol.",
    err_sprite_exists: "Un sprite cu acest nume există deja.",
    err_project_exists: "Un proiect cu acest nume există deja.",
    err_no_content: "Nu există conținut de salvat.",
    err_no_changes: "Nicio modificare de salvat.",
    err_delete_last_sheet: "Nu se poate șterge ultima foaie.",
    err_extract_frames: "Nu s-au putut extrage niciun cadru.",
    err_indexeddb: "Salvarea locală a eșuat. Este posibil ca browserul dvs. să nu accepte IndexedDB.",
    msg_upload_success: "Încărcare reușită: {0}",
    msg_upload_failed: "Încărcarea eșuată: {0}",
    msg_save_success: "Salvare reușită.",
    msg_saving: "Economisire...",
    msg_multi_save_result: "S-au salvat {0} elemente. {1} eșecuri.",
    menu_title: "Meniu",
    menu_save: "Salva",
    menu_save_all: "Salvați tot",
    menu_support: "Contactați asistența",
    label_local_storage: "Stocare locală",
    label_sign_in: "Conectare",
    modal_export_title: "Export Sprite",
    label_filename: "Nume de fișier",
    label_format: "Format",
    action_export_confirm: "Export",
};

export default translations;
